import {parseId} from '../../helpers'
import {PolicyFilters} from './policiesTypes'

/**
 * Traduce los filtros de la lista (pólizas o cotizaciones) a los query params
 * que esperan los endpoints de export de Excel del backend.
 */
export const buildPolicyExportParams = (
  formData: PolicyFilters,
  selectedYears: number[],
  tabFilters: string,
  searchByMembers: boolean
): URLSearchParams => {
  const toParam = (value: unknown) => {
    if (value == null || value === '') return null
    if (Array.isArray(value)) return value.map(String).join(',')
    return String(value)
  }

  const rawParams: Record<string, string | null | undefined> = {
    isImportant: tabFilters === 'Important' ? 'true' : null,
    archived: tabFilters === 'Archived' ? 'true' : null,
    hasReminders: tabFilters === 'Reminders' ? 'true' : null,
    holderName: searchByMembers ? null : formData.policyName,
    memberName: searchByMembers ? formData.policyName : null,
    effectiveYear: selectedYears.length > 0 ? selectedYears.join(',') : null,
    insuranceCategory: toParam(formData.insuranceCategory),
    carrier: toParam(formData.carrier),
    user: toParam(formData.user),
    assignedTo: toParam(formData.assignedTo),
    signatureForm: Array.isArray(formData.signatureForm) && formData.signatureForm.length > 0
      ? formData.signatureForm.map((id: string) => parseId(id)).join(',')
      : null,
    signatureStatus: formData.signatureStatus || null,
    agentOfRecord: Array.isArray(formData.agentOfRecord) && formData.agentOfRecord.length > 0
      ? formData.agentOfRecord.map((id: string) => parseId(id)).join(',')
      : null,
    stateEU: toParam(formData.stateEU),
    stateJurisdictionType: formData.stateJurisdictionType || null,
    status: toParam(formData.status),
    documentStatus: toParam(formData.documentStatus),
    paymentStatus: toParam(formData.paymentStatus),
    metalLevel: formData.metalLevel || null,
    leadSource: toParam(formData.leadSource),
    policyType: toParam(formData.policyType),
    immigrationStatus: toParam(formData.immigrationStatus),
    holderGender: formData.holderGender || null,
    unassigned: formData.unassigned === true ? 'true' : formData.unassigned === false ? 'false' : null,
    hasMemberId: formData.hasMemberId === true ? 'true' : formData.hasMemberId === false ? 'false' : null,
    commissionPayable: formData.commissionPayable === true ? 'true' : formData.commissionPayable === false ? 'false' : null,
    commissionPaymentStatus: formData.commissionPaymentStatus || null,
    advisorPaid: formData.advisorPaid === true ? 'true' : formData.advisorPaid === false ? 'false' : null,
    advisorChargeback: formData.advisorChargeback === true ? 'true' : formData.advisorChargeback === false ? 'false' : null,
    ownsCar: formData.ownsCar === true ? 'true' : formData.ownsCar === false ? 'false' : null,
    ownsHome: formData.ownsHome === true ? 'true' : formData.ownsHome === false ? 'false' : null,
    hasAutoPolicy: formData.hasAutoPolicy === true ? 'true' : formData.hasAutoPolicy === false ? 'false' : null,
    hasHomePolicy: formData.hasHomePolicy === true ? 'true' : formData.hasHomePolicy === false ? 'false' : null,
    hasCarrierAccount: formData.hasCarrierAccount === true ? 'true' : formData.hasCarrierAccount === false ? 'false' : null,
    accountCreatedByClient: formData.accountCreatedByClient === true ? 'true' : formData.accountCreatedByClient === false ? 'false' : null,
    createdAfter: formData.createdAfter,
    createdBefore: formData.createdBefore,
    effectiveDateAfter: formData.effectiveDateAfter,
    effectiveDateBefore: formData.effectiveDateBefore,
    documentsDueDateAfter: formData.documentsDueDateAfter,
    documentsDueDateBefore: formData.documentsDueDateBefore,
    paymentStatusDateAfter: formData.paymentStatusDateAfter,
    paymentStatusDateBefore: formData.paymentStatusDateBefore,
    advisorPaidDateAfter: formData.advisorPaidDateAfter,
    advisorPaidDateBefore: formData.advisorPaidDateBefore,
    advisorChargebackDateAfter: formData.advisorChargebackDateAfter,
    advisorChargebackDateBefore: formData.advisorChargebackDateBefore,
    carrierStatusGeneric: toParam(formData.carrierStatusGeneric),
    carrierStatusRaw: formData.carrierStatusRaw || null,
    carrierLastAsOfDateAfter: formData.carrierLastAsOfDateAfter || null,
    carrierLastAsOfDateBefore: formData.carrierLastAsOfDateBefore || null,
    carrierIsAgeIn:
      formData.carrierIsAgeIn === true ? 'true' : formData.carrierIsAgeIn === false ? 'false' : null,
    carrierIsDelinquent:
      formData.carrierIsDelinquent === true ? 'true' : formData.carrierIsDelinquent === false ? 'false' : null,
    carrierIsUnpaidPending:
      formData.carrierIsUnpaidPending === true
        ? 'true'
        : formData.carrierIsUnpaidPending === false
          ? 'false'
          : null,
    carrierIsUnpaidPastDue:
      formData.carrierIsUnpaidPastDue === true
        ? 'true'
        : formData.carrierIsUnpaidPastDue === false
          ? 'false'
          : null,
    carrierNoImportData:
      formData.carrierNoImportData === true
        ? 'true'
        : formData.carrierNoImportData === false
          ? 'false'
          : null,
    canceledAfter: formData.canceledAfter,
    canceledBefore: formData.canceledBefore,
    acaResult: toParam(formData.acaResult) || null,
    acaValidity: formData.acaValidity || null,
  }

  const params = new URLSearchParams()
  Object.entries(rawParams).forEach(([key, value]) => {
    if (value != null && value !== '') {
      params.append(key, value)
    }
  })

  return params
}
